export const CURRENCY_SYMBOL = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  CAD: "$",
  AUD: "$",
} as const;

export const SUPPORTED_CURRENCIES = {
  USD: "USD",
  EUR: "EUR",
  GBP: "GBP",
  CAD: "CAD",
  AUD: "AUD",
} as const;

export interface CurrencyProps {
  code: keyof typeof SUPPORTED_CURRENCIES;
  symbol: (typeof CURRENCY_SYMBOL)[keyof typeof CURRENCY_SYMBOL];
}

export interface CurrencyConversionRates {
  [key: string]: number;
}

export interface CurrencyContextProps {
  currency: CurrencyProps;
  setCurrency: (data: CurrencyProps) => void;
  currencyConversionRates: CurrencyConversionRates;
  setCurrencyConversionRates: (data: CurrencyConversionRates) => void;
}
